import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Gonggao = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 20 20"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="c73cb__a">
              <rect
                rx="0"
                height="20"
                width="20"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#c73cb__a)">
            <path
              fill="#9D4FE6"
              d="M1.667 15.417v-7.5c0-.92.746-1.667 1.666-1.667h13.334c.92 0 1.666.746 1.666 1.667v7.5c0 .92-.746 1.666-1.666 1.666H3.333c-.92 0-1.666-.746-1.666-1.666Z"
            />
            <path
              fill="#9D4FE6"
              fillRule="evenodd"
              d="M1.042 7.917v7.5q0 .949.67 1.62.672.671 1.621.671h13.334q.949 0 1.62-.67.671-.672.671-1.621v-7.5q0-.95-.67-1.62-.672-.672-1.621-.672H3.333q-.949 0-1.62.671-.671.671-.671 1.62Zm1.555 8.236q-.305-.305-.305-.736v-7.5q0-.432.305-.737t.736-.305h13.334q.431 0 .736.305t.305.737v7.5q0 .431-.305.736t-.736.305H3.333q-.431 0-.736-.305Z"
            />
            <path
              fill="#9D4FE6"
              d="M10 2.917 6.667 6.25h6.666L10 2.917Z"
            />
            <path
              fill="#9D4FE6"
              fillRule="evenodd"
              d="M13.958 6.25a.625.625 0 0 0-.183-.442l-3.333-3.333a.625.625 0 0 0-.884 0L6.225 5.808a.625.625 0 0 0 .442 1.067h6.666c.345 0 .625-.28.625-.625Zm-2.134-.625L10 3.801 8.176 5.625h3.648Z"
            />
            <path
              fill="#F7E8FF"
              fillRule="evenodd"
              d="M5 10.625h7.5a.625.625 0 1 0 0-1.25H5a.625.625 0 1 0 0 1.25Zm0 3.333h3.333a.625.625 0 1 0 0-1.25H5a.625.625 0 1 0 0 1.25Z"
            />
          </g>
        </g>
      </svg>
    )
  }
)
